import { render, staticRenderFns } from "./AccountantNotifications.vue?vue&type=template&id=952443b8&scoped=true"
import script from "./AccountantNotifications.vue?vue&type=script&lang=ts"
export * from "./AccountantNotifications.vue?vue&type=script&lang=ts"
import style0 from "./AccountantNotifications.vue?vue&type=style&index=0&id=952443b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952443b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('952443b8')) {
      api.createRecord('952443b8', component.options)
    } else {
      api.reload('952443b8', component.options)
    }
    module.hot.accept("./AccountantNotifications.vue?vue&type=template&id=952443b8&scoped=true", function () {
      api.rerender('952443b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountantNotifications.vue"
export default component.exports